module.exports = __webpack_public_path__ + "static/year1997-2ded262d20e6a924c6be05e77081fd8d.jpg";